import React, { type FC } from 'react';
import { IconTile } from '@atlaskit/icon';
import OfficeBuildingIcon from '@atlaskit/icon/core/office-building';
import TagIcon from '@atlaskit/icon/core/tag';
import type { GlyphProps } from '@atlaskit/icon/types';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

type LabelIcon = {
	size: 'large' | 'small' | 'xsmall';
	type: 'ORGANIZATION' | 'PRODUCT';
	label?: string;
} & Omit<GlyphProps, 'size' | 'label'>;

export const LabelIcon: FC<LabelIcon> = ({ size, type, label = '', testId, ...etc }) => {
	const Icon = type === 'ORGANIZATION' ? OfficeBuildingIcon : TagIcon;
	const isLarge = size === 'large';

	return (
		<Box
			xcss={[containerStyles, size === 'small' && smallStyles, size === 'xsmall' && xsmallStyles]}
			testId={testId}
		>
			{isLarge ? (
				<IconTile icon={Icon} appearance="gray" shape="square" size="40" label={label} />
			) : (
				<Icon color={token('color.icon')} label={label} {...etc} />
			)}
		</Box>
	);
};

const containerStyles = xcss({
	display: 'flex',
	backgroundColor: 'color.background.neutral',
});

const smallStyles = xcss({
	borderRadius: 'radius.xsmall',
	padding: 'space.050',
});

const xsmallStyles = xcss({
	borderRadius: 'radius.xsmall',
	padding: 'space.025',
});
